import { withStyles } from '@material-ui/core';
import { SummaryItem } from './index';

const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '8 0',
    '& > div:not(:last-child)': {
      borderRight: `1px solid ${theme.KPI.KPIButton}`,
      marginRight: '8px'
    }
  }
});

const Summary = ({ classes, summaryData }) => {
  return (
    <div className={classes.container}>
      {summaryData.map((kpi, index) => (
        <SummaryItem key={index} label={kpi.label} value={kpi.value} />
      ))}
    </div>
  );
};

export default withStyles(styles)(Summary);
